export const backgroundColor = '#F8F9FB';
